import React from 'react';
import { Link } from 'react-router-dom';
import { COMPLETE_HELP_ROUTES } from '../../../routes/routes.config';

const DashboardHelp = () => {
  const quickAccessItems = [
    {
      title: 'Crear Ticket',
      description: 'Reporta problemas o solicita ayuda técnica',
      route: COMPLETE_HELP_ROUTES.tickets.path,
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v2Z"/>
          <path d="M13 5v2"/>
          <path d="M13 17v2"/>
          <path d="M13 11v2"/>
        </svg>
      ),
      color: 'blue'
    },
    {
      title: 'Documentación API',
      description: 'Consulta la documentación completa de la API',
      route: COMPLETE_HELP_ROUTES.api.path,
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <polyline points="16,18 22,12 16,6"/>
          <polyline points="8,6 2,12 8,18"/>
        </svg>
      ),
      color: 'green'
    },
    {
      title: 'Base de Datos',
      description: 'Información sobre estructura y esquemas',
      route: COMPLETE_HELP_ROUTES.database.path,
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <ellipse cx="12" cy="5" rx="9" ry="3"/>
          <path d="m3 5v14c0 1.66 4.03 3 9 3s9-1.34 9-3V5"/>
          <path d="M3 12c0 1.66 4.03 3 9 3s9-1.34 9-3"/>
        </svg>
      ),
      color: 'purple'
    },
    {
      title: 'Contacto',
      description: 'Comunícate directamente con el equipo',
      route: COMPLETE_HELP_ROUTES.contact.path,
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
        </svg>
      ),
      color: 'orange'
    }
  ];

  const recentActivity = [
    {
      type: 'ticket',
      title: 'Problema con sincronización de datos',
      status: 'En progreso',
      date: '2 horas',
      priority: 'Alta'
    },
    {
      type: 'documentation',
      title: 'Actualización API v2.1',
      status: 'Completado',
      date: '1 día',
      priority: 'Media'
    },
    {
      type: 'ticket',
      title: 'Error en módulo de reportes',
      status: 'Resuelto',
      date: '3 días',
      priority: 'Baja'
    }
  ];

  const getColorClass = (color) => {
    const colorMap = {
      blue: 'border-blue-200 bg-blue-50 text-blue-700 hover:bg-blue-100',
      green: 'border-green-200 bg-green-50 text-green-700 hover:bg-green-100',
      purple: 'border-purple-200 bg-purple-50 text-purple-700 hover:bg-purple-100',
      orange: 'border-orange-200 bg-orange-50 text-orange-700 hover:bg-orange-100'
    };
    return colorMap[color] || colorMap.blue;
  };

  const getPriorityColor = (priority) => {
    const priorityMap = {
      'Alta': 'text-red-600 bg-red-100',
      'Media': 'text-yellow-600 bg-yellow-100',
      'Baja': 'text-green-600 bg-green-100'
    };
    return priorityMap[priority] || priorityMap['Media'];
  };

  const getStatusColor = (status) => {
    const statusMap = {
      'En progreso': 'text-blue-600 bg-blue-100',
      'Completado': 'text-green-600 bg-green-100',
      'Resuelto': 'text-purple-600 bg-purple-100'
    };
    return statusMap[status] || statusMap['En progreso'];
  };

  return (
    <div className="help-dashboard">
      {/* Header Section */}
      <div className="dashboard-header">
        <h1 className="dashboard-title">
          Bienvenido al Centro de Ayuda
        </h1>
        <p className="dashboard-subtitle">
          Encuentra respuestas, consulta documentación y obtén soporte técnico para el sistema GroundMaster.
        </p>
      </div>

      {/* Quick Access Grid */}
      <div className="quick-access-section">
        <h2 className="section-title">Acceso Rápido</h2>
        <div className="quick-access-grid">
          {quickAccessItems.map((item, index) => (
            <Link
              key={index}
              to={item.route}
              className={`quick-access-card ${getColorClass(item.color)}`}
            >
              <div className="card-icon">
                {item.icon}
              </div>
              <div className="card-content">
                <h3 className="card-title">{item.title}</h3>
                <p className="card-description">{item.description}</p>
              </div>
              <div className="card-arrow">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <polyline points="9,18 15,12 9,6"/>
                </svg>
              </div>
            </Link>
          ))}
        </div>
      </div>

      {/* Recent Activity */}
      <div className="recent-activity-section">
        <div className="activity-header">
          <h2 className="section-title">Actividad Reciente</h2>
          <Link to={COMPLETE_HELP_ROUTES.tickets.path} className="view-all-link">
            Ver todos los tickets
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polyline points="9,18 15,12 9,6"/>
            </svg>
          </Link>
        </div>
        
        <div className="activity-list">
          {recentActivity.map((activity, index) => (
            <div key={index} className="activity-item">
              <div className="activity-icon">
                {activity.type === 'ticket' ? (
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v2Z"/>
                  </svg>
                ) : (
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                    <polyline points="14,2 14,8 20,8"/>
                  </svg>
                )}
              </div>
              
              <div className="activity-content">
                <div className="activity-title">{activity.title}</div>
                <div className="activity-meta">
                  Hace {activity.date}
                </div>
              </div>
              
              <div className="activity-badges">
                <span className={`status-badge ${getStatusColor(activity.status)}`}>
                  {activity.status}
                </span>
                <span className={`priority-badge ${getPriorityColor(activity.priority)}`}>
                  {activity.priority}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Help Categories */}
      <div className="help-categories-section">
        <h2 className="section-title">Categorías de Ayuda</h2>
        <div className="categories-grid">
          <div className="category-card">
            <div className="category-header">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                <polyline points="14,2 14,8 20,8"/>
              </svg>
              <h3>Documentación</h3>
            </div>
            <ul className="category-links">
              <li><Link to={COMPLETE_HELP_ROUTES.api.path}>API Reference</Link></li>
              <li><Link to={COMPLETE_HELP_ROUTES.database.path}>Base de Datos</Link></li>
              <li><Link to={COMPLETE_HELP_ROUTES.backend.path}>Backend</Link></li>
              <li><Link to={COMPLETE_HELP_ROUTES.frontend.path}>Frontend</Link></li>
            </ul>
          </div>

          <div className="category-card">
            <div className="category-header">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <rect width="18" height="11" x="3" y="11" rx="2" ry="2"/>
                <circle cx="12" cy="16" r="1"/>
                <path d="m7 11V7a5 5 0 0 1 10 0v4"/>
              </svg>
              <h3>Privacidad</h3>
            </div>
            <ul className="category-links">
              <li><Link to={COMPLETE_HELP_ROUTES.accessibility.path}>Accesibilidad</Link></li>
              <li><Link to={COMPLETE_HELP_ROUTES.dataProcessing.path}>Tratamiento de Datos</Link></li>
              <li><Link to={COMPLETE_HELP_ROUTES.termsConditions.path}>Términos y Condiciones</Link></li>
              <li><Link to={COMPLETE_HELP_ROUTES.informationProtection.path}>Sistema de Protección de la Información</Link></li>
            </ul>
          </div>
        </div>
      </div>

      <style jsx>{`
        .help-dashboard {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0;
        }

        .dashboard-header {
          margin-bottom: 2rem;
          text-align: center;
        }

        .dashboard-title {
          font-size: 2rem;
          font-weight: 600;
          margin-bottom: 0.5rem;
          color: var(--text-primary);
        }

        .dashboard-subtitle {
          font-size: 1.1rem;
          color: var(--text-secondary);
          max-width: 600px;
          margin: 0 auto;
          line-height: 1.6;
        }

        .section-title {
          font-size: 1.25rem;
          font-weight: 600;
          margin-bottom: 1rem;
          color: var(--text-primary);
        }

        .quick-access-section {
          margin-bottom: 3rem;
        }

        .quick-access-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
          gap: 1rem;
        }

        .quick-access-card {
          display: flex;
          align-items: center;
          padding: 1.5rem;
          border: 1px solid;
          border-radius: 8px;
          text-decoration: none;
          transition: all 0.2s ease;
          cursor: pointer;
        }

        .card-icon {
          width: 48px;
          height: 48px;
          margin-right: 1rem;
          flex-shrink: 0;
        }

        .card-icon svg {
          width: 100%;
          height: 100%;
        }

        .card-content {
          flex: 1;
        }

        .card-title {
          font-size: 1.1rem;
          font-weight: 600;
          margin-bottom: 0.25rem;
        }

        .card-description {
          font-size: 0.9rem;
          opacity: 0.8;
          line-height: 1.4;
        }

        .card-arrow {
          margin-left: 1rem;
          opacity: 0.6;
          transition: transform 0.2s ease;
        }

        .quick-access-card:hover .card-arrow {
          transform: translateX(4px);
        }

        .recent-activity-section {
          margin-bottom: 3rem;
        }

        .activity-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 1rem;
        }

        .view-all-link {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          color: #4CAF50;
          text-decoration: none;
          font-size: 0.9rem;
          font-weight: 500;
          transition: color 0.2s ease;
        }

        .view-all-link:hover {
          color: #3e8e41;
        }

        .activity-list {
          background: var(--bg-secondary);
          border: 1px solid var(--border-color);
          border-radius: 8px;
          overflow: hidden;
        }

        .activity-item {
          display: flex;
          align-items: center;
          padding: 1rem;
          border-bottom: 1px solid var(--border-color);
          transition: background-color 0.2s ease;
        }

        .activity-item:last-child {
          border-bottom: none;
        }

        .activity-item:hover {
          background: var(--bg-hover);
        }

        .activity-icon {
          width: 40px;
          height: 40px;
          background: var(--bg-primary);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 1rem;
          color: var(--text-secondary);
        }

        .activity-content {
          flex: 1;
        }

        .activity-title {
          font-weight: 500;
          margin-bottom: 0.25rem;
          color: var(--text-primary);
        }

        .activity-meta {
          font-size: 0.85rem;
          color: var(--text-secondary);
        }

        .activity-badges {
          display: flex;
          gap: 0.5rem;
        }

        .status-badge,
        .priority-badge {
          padding: 0.25rem 0.5rem;
          border-radius: 4px;
          font-size: 0.75rem;
          font-weight: 500;
        }

        .help-categories-section {
          margin-bottom: 2rem;
        }

        .categories-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
          gap: 1.5rem;
        }

        .category-card {
          background: var(--bg-secondary);
          border: 1px solid var(--border-color);
          border-radius: 8px;
          padding: 1.5rem;
        }

        .category-header {
          display: flex;
          align-items: center;
          margin-bottom: 1rem;
        }

        .category-header svg {
          margin-right: 0.75rem;
          color: var(--text-secondary);
        }

        .category-header h3 {
          font-size: 1.1rem;
          font-weight: 600;
          color: var(--text-primary);
        }

        .category-links {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .category-links li {
          margin-bottom: 0.5rem;
        }

        .category-links a {
          color: var(--text-secondary);
          text-decoration: none;
          font-size: 0.9rem;
          transition: color 0.2s ease;
        }

        .category-links a:hover {
          color: #4CAF50;
        }

        /* CSS Variables para temas */
        :root {
          --text-primary: #1e293b;
          --text-secondary: #64748b;
          --bg-primary: #f8fafc;
          --bg-secondary: #ffffff;
          --bg-hover: #f1f5f9;
          --border-color: #e2e8f0;
        }

        [data-theme="dark"] {
          --text-primary: #e2e8f0;
          --text-secondary: #94a3b8;
          --bg-primary: #1a1a1a;
          --bg-secondary: #2d2d2d;
          --bg-hover: #404040;
          --border-color: #404040;
        }

        @media (max-width: 768px) {
          .quick-access-grid {
            grid-template-columns: 1fr;
          }

          .categories-grid {
            grid-template-columns: 1fr;
          }

          .activity-header {
            flex-direction: column;
            align-items: flex-start;
            gap: 0.5rem;
          }
        }
      `}</style>
    </div>
  );
};

export default DashboardHelp;